module.exports = __webpack_public_path__ + "static/media/CecoCare-banner.c8d07dee.jpg";